import React from "react";
import { Modal } from "react-bootstrap";
import { MdClose } from "react-icons/md";

const PaymentModal = ({ showModal,onClose, paymentLinkData }) => {
  console.log("show :::",showModal)
  return (
    <Modal
      show={showModal}
      onHide={onClose}
      size="lg"
      backdrop="static"
      centered
      style={{
        textAlign: "center",
      }}
    >
      <Modal.Body
        style={{
          width: "100%",
          maxWidth: "900px",
          height: "auto",
          maxHeight: "90vh",
          margin: "0 auto",
          padding: "0",
          position: "relative",
        }}
      >
        <iframe
          src={paymentLinkData?.redirectURL}
          title="Payment Confirmation"
          style={{
            width: "100%",
            height: "80vh",
            border: "none",
          }}
        ></iframe>
        {/* adsolute close icon */}
        <div
          onClick={onClose}
          style={{
            position: "absolute",
            top: "-0.8em",
            borderRadius: 20,
            border: "1px solid #ddd",
            cursor: "pointer",
            right: "-0.8em",
            padding: 5,
            background: "#fff",
          }}
        >
          <MdClose style={{ fontSize: 25, color: "red" }} />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PaymentModal;
